import { observer, Provider } from "mobx-react";
import * as React from "react";
import { Notice } from "telia-front-react";
import RootStore from "../stores/RootStore.mjs";
import ErrorBoundary from "./ErrorBoundary.mjs";
import PaymentTemplate from "./PaymentTemplate.mjs";
class Payment extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      rootStore: RootStore.instance(),
      paymentMethodsHasError: false
    };
    this.state.rootStore.apiService.setEnvironment(this.props.environment);
    this.state.rootStore.settingsStore.load();
    try {
      this.state.rootStore.tabStore.initializePaymentMethods(this.props.paymentMethods);
    } catch (error) {
      this.state = { ...this.state, paymentMethodsHasError: true };
    }
    const { paymentStore, brandStore } = this.state.rootStore;
    this.props.brand && brandStore.setBrand(this.props.brand);
    paymentStore.setInitialAmount(this.props.initialAmount);
    paymentStore.setAmountFieldState("READY_FOR_PAYMENT");
    paymentStore.setPaymentStatus("NEW");
  }
  componentDidMount() {
    const { language } = this.props;
    this.state.rootStore.translateStore.getTranslations(language);
    document.documentElement.setAttribute("lang", language);
  }
  componentDidUpdate(prevProps) {
    const { translateStore, paymentStore } = this.state.rootStore;
    const { language, initialAmount } = this.props;
    if (prevProps.initialAmount !== initialAmount) {
      paymentStore.setInitialAmount(initialAmount);
    }
    if (prevProps.language !== language) {
      translateStore.changeTranslationLanguage(language);
      document.documentElement.setAttribute("lang", language);
    }
  }
  render() {
    const { translate } = this.state.rootStore.translateStore;
    if (!this.hasMandatoryParameters()) {
      return /* @__PURE__ */ React.createElement(Notice, { type: "error" }, translate("payment.errors.parameters-missing"));
    }
    if (this.state.paymentMethodsHasError) {
      return /* @__PURE__ */ React.createElement(Notice, { type: "error" }, translate("payment.errors.payment-methods-invalid"));
    }
    return /* @__PURE__ */ React.createElement(Provider, { ...this.state.rootStore }, /* @__PURE__ */ React.createElement(ErrorBoundary, { onErrorCaught: this.props.onErrorCaught }, /* @__PURE__ */ React.createElement(
      PaymentTemplate,
      {
        paymentProps: this.props,
        noticeProps: { type: this.props.noticeType, children: this.props.noticeLabel }
      }
    )));
  }
  hasMandatoryParameters() {
    const { referenceNumber, paymentMethods, source, amountFieldReadOnly, initialAmount, headless } = this.props;
    if (!referenceNumber || !source) {
      return false;
    }
    if (paymentMethods.includes("banklinks") && !this.validBanklinkPaymentProps) {
      return false;
    }
    if (paymentMethods.includes("card") && !this.props.cardPayment?.returnUrl) {
      return false;
    }
    if (amountFieldReadOnly && !initialAmount) {
      return false;
    }
    if (headless && !(initialAmount && initialAmount > 0)) {
      return false;
    }
    return true;
  }
  get validBanklinkPaymentProps() {
    if (!this.props.banklinkPayment) {
      return false;
    }
    const { successUrl, processingUrl, failedUrl } = this.props.banklinkPayment;
    return successUrl != null && processingUrl != null && failedUrl != null;
  }
}
const Payment$1 = observer(Payment);
export {
  Payment$1 as default
};
